function parseDigits(string: string, match: RegExp) {
  return (string.match(match) || []).join("");
}

export function formatPhoneNumber(
  value: string | undefined | null,
  match: RegExp,
  separator: string,
  countryCode?: string,
  shouldRemoveCountryCode?: boolean
) {
  if (!value) {
    return "";
  }

  if (shouldRemoveCountryCode) {
    value = value.slice(2);
  }

  const digits = [...parseDigits(value, match)].entries();
  let result = "";

  if (countryCode) {
    result = `${countryCode} `;
  }

  for (const [index, digit] of digits) {
    if (index === 9) {
      return result;
    }
    if (index === 3 || index === 6) {
      result = `${result}${separator}`;
    }
    result = `${result}${digit}`;
  }

  return result;
}
